<template>
  <svg
    v-if="name === 'users'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 50 50"
    stroke="currentColor"
  >
    <g>
      <path 
      d="M15.79,17.2c-0.03-5.32,4.09-9.75,9.14-9.82c5.01-0.07,9.26,4.43,9.28,9.83c0.02,5.4-4.17,9.91-9.22,9.91
        C19.97,27.11,15.83,22.65,15.79,17.2z"/>
      <path 
      d="M49.66,25C49.66,11.38,38.62,0.34,25,0.34C11.38,0.34,0.34,11.38,0.34,25c0,13.62,11.04,24.66,24.66,24.66
        C38.62,49.66,49.66,38.62,49.66,25z M6.67,36.75C1.68,30.03,1.29,17.75,9.47,9.55c8.12-8.13,20.74-8.63,29.74-1.17
        c8.32,6.9,10.2,19.55,4.2,28.36C31.09,27.7,18.89,27.62,6.67,36.75z"/>
    </g>
  </svg>
  <svg
    v-else-if="name === 'v-rooms'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 50 50"
    stroke="currentColor"
  >
    <g>
      <path 
      d="M12.07,25.32l12.17,18.15c0.21,0.3,0.55,0.49,0.92,0.49c0.37,0,0.71-0.18,0.92-0.49l12.19-18.15
        c1.63-2.4,2.59-5.19,2.78-8.08s-0.39-5.78-1.68-8.38h0c-1.18-2.5-3-4.63-5.28-6.19c-2.28-1.55-4.94-2.47-7.69-2.64
        c-0.82-0.06-1.63-0.06-2.45,0c-2.76,0.18-5.41,1.09-7.69,2.64c-2.28,1.55-4.11,3.69-5.28,6.19c-1.29,2.59-1.87,5.48-1.68,8.38
        C9.48,20.14,10.44,22.93,12.07,25.32z M19.51,9.51c1.49-1.5,3.51-2.34,5.62-2.35c2.11-0.01,4.14,0.82,5.64,2.31
        c1.5,1.49,2.35,3.51,2.36,5.62c0.01,2.12-0.83,4.16-2.32,5.66c-1.49,1.5-3.53,2.35-5.65,2.35v0c-2.11,0-4.13-0.84-5.63-2.33
        c-1.49-1.49-2.34-3.51-2.34-5.62C17.19,13.03,18.02,11.01,19.51,9.51z"/>
      <path 
      d="M43.03,41.09c-0.61-0.75-1.45-1.29-2.39-1.52v0h-0.13l-5.39-0.97c-0.61-0.11-1.19,0.3-1.3,0.91
        c-0.11,0.61,0.3,1.19,0.91,1.3l5.31,0.96c0.47,0.1,0.9,0.35,1.22,0.71c0.32,0.36,0.51,0.82,0.54,1.3c-0.06,0.5-0.27,0.96-0.62,1.33
        c-0.35,0.36-0.8,0.6-1.3,0.67c-9.64,2.61-19.79,2.64-29.44,0.09v0l-0.24-0.07c-1.42-0.37-1.94-1.29-1.94-2.02
        c0.05-0.46,0.25-0.89,0.56-1.24c0.31-0.34,0.73-0.58,1.18-0.67h0l5.58-0.96c0.61-0.1,1.02-0.68,0.92-1.29
        c-0.1-0.61-0.68-1.02-1.29-0.92l-5.66,0.97H9.42c-1.31,0.25-2.43,1.11-3.01,2.31c-0.58,1.21-0.55,2.61,0.07,3.8
        c0.62,1.18,1.77,2,3.1,2.2l0.33,0.07c4.93,1.3,10.02,1.96,15.12,1.95l0,0c5.22,0.01,10.41-0.68,15.45-2.05
        c0.98-0.2,1.86-0.72,2.5-1.49c0.64-0.76,1.01-1.72,1.03-2.72C43.98,42.77,43.64,41.84,43.03,41.09z"/>
    </g>
  </svg>
  <svg
    v-else-if="name === 'cog'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="tw-h-6 tw-w-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'award'"
    stroke="currentColor"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.7997 48C26.8997 48 20.9997 48 15.0997 48C14.9997 47.9 14.8997 47.9 14.7997 47.8C13.7997 47.4 13.2997 46.7 13.2997 45.7C13.2997 44.6 13.7997 44 14.6997 43.5C17.4997 42.2 19.1997 40 19.9997 37.1C20.0997 36.6 19.9997 36.3 19.5997 35.9C18.0997 34.5 16.6997 33.1 15.1997 31.6C14.7997 31.2 14.4997 30.8 13.9997 30.6C6.49969 26.3 1.79969 20 0.39969 11.3C-0.20031 8.2 1.59969 6 4.79969 6C5.99969 6 7.19969 6 8.39969 6C8.39969 5.6 8.49969 5.3 8.49969 5.1C8.49969 2 9.19969 1.1 11.9997 0C19.9997 0 27.9997 0 35.9997 0C39.0997 0.8 39.7997 3.1 39.4997 6C40.8997 6 42.1997 6 43.4997 6C46.3997 6.1 48.1997 8.3 47.6997 11.2C46.1997 19.9 41.4997 26.3 33.8997 30.6C33.4997 30.8 33.0997 31.3 32.6997 31.6C31.1997 33 29.7997 34.5 28.2997 35.9C27.8997 36.3 27.6997 36.6 27.8997 37.1C28.6997 40 30.3997 42 32.9997 43.5C33.5997 43.8 34.1997 44.3 34.4997 44.9C34.9997 46.1 34.3997 47.1 32.7997 48ZM24.0997 2.4C20.3997 2.4 16.5997 2.4 12.8997 2.4C11.4997 2.4 10.7997 3.1 10.7997 4.5C10.8997 10.6 11.5997 16.6 13.4997 22.4C14.7997 26.2 16.3997 29.8 19.2997 32.6C22.3997 35.6 25.6997 35.6 28.8997 32.6C30.9997 30.5 32.3997 28 33.5997 25.3C36.3997 18.7 37.2997 11.7 37.3997 4.6C37.3997 3.2 36.6997 2.5 35.1997 2.5C31.3997 2.4 27.6997 2.4 24.0997 2.4ZM12.6997 26.8C10.0997 20.8 8.99969 14.7 8.49969 8.4C6.99969 8.4 5.59969 8.3 4.29969 8.4C3.09969 8.5 2.39969 9.5 2.59969 10.8C3.29969 15 4.89969 18.8 7.49969 22.1C8.89969 23.8 10.4997 25.4 12.6997 26.8ZM35.4997 26.6C40.9997 22.6 44.2997 17.3 45.2997 10.5C45.4997 9.5 44.7997 8.5 43.7997 8.4C42.2997 8.3 40.8997 8.4 39.2997 8.4C38.9997 14.7 37.8997 20.8 35.4997 26.6ZM31.5997 45.6C28.2997 43.6 26.2997 40.8 25.3997 37.2C24.3997 37.2 23.4997 37.2 22.4997 37.2C21.6997 40.9 19.4997 43.6 15.9997 45.6C21.4997 45.6 26.4997 45.6 31.5997 45.6Z"
      fill="currentColor"
    />
    <path
      d="M23.9996 8.50064C25.0996 8.50064 25.8996 9.00064 26.1996 10.0006C26.6996 11.3006 27.3996 12.0006 28.8996 12.0006C29.8996 12.0006 30.6996 12.7006 30.9996 13.7006C31.2996 14.7006 31.0996 15.5006 30.3996 16.3006C30.2996 16.4006 30.2996 16.5006 30.1996 16.5006C28.9996 17.2006 28.8996 18.3006 29.1996 19.5006C29.4996 20.6006 29.1996 21.6006 28.2996 22.2006C27.3996 22.9006 26.2996 22.8006 25.3996 22.2006C24.3996 21.5006 23.4996 21.5006 22.4996 22.2006C21.5996 22.8006 20.5996 22.9006 19.5996 22.2006C18.5996 21.5006 18.2996 20.5006 18.6996 19.4006C19.0996 18.1006 18.6996 17.2006 17.6996 16.4006C16.7996 15.7006 16.5996 14.7006 16.8996 13.6006C17.2996 12.5006 18.0996 11.9006 19.2996 11.9006C20.4996 11.9006 21.1996 11.3006 21.4996 10.2006C21.9996 9.20064 22.7996 8.40064 23.9996 8.50064ZM20.9996 20.4006C22.9996 18.8006 24.9996 18.9006 26.9996 20.4006C26.0996 17.8006 26.8996 16.0006 28.8996 14.4006C26.1996 14.5006 24.6996 13.2006 23.9996 10.7006C23.2996 13.2006 21.6996 14.4006 19.0996 14.4006C21.0996 16.0006 21.8996 17.9006 20.9996 20.4006Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else-if="name === 'search'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
  <svg v-else-if="name === 'add_user'" fill="none" viewBox="0 0 24 24">
    <circle
      cx="12"
      cy="8"
      r="3.25"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M12.25 19.25H6.94953C5.77004 19.25 4.88989 18.2103 5.49085 17.1954C6.36247 15.7234 8.23935 14 12.25 14"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M17 14.75V19.25"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M19.25 17L14.75 17"
    />
  </svg>
  <svg v-else-if="name === 'phone'" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M8.89286 4.75H6.06818C5.34017 4.75 4.75 5.34017 4.75 6.06818C4.75 13.3483 10.6517 19.25 17.9318 19.25C18.6598 19.25 19.25 18.6598 19.25 17.9318V15.1071L16.1429 13.0357L14.5317 14.6468C14.2519 14.9267 13.8337 15.0137 13.4821 14.8321C12.8858 14.524 11.9181 13.9452 10.9643 13.0357C9.98768 12.1045 9.41548 11.1011 9.12829 10.494C8.96734 10.1537 9.06052 9.76091 9.32669 9.49474L10.9643 7.85714L8.89286 4.75Z"
    />
  </svg>
  <svg v-else-if="name === 'email'" fill="none" viewBox="0 0 24 24">
    <circle
      cx="12"
      cy="12"
      r="3.25"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C18.8125 4.75 19.25 9.125 19.25 12V13.25C19.25 14.3546 18.3546 15.25 17.25 15.25V15.25C16.1454 15.25 15.25 14.3546 15.25 13.25V8.75"
    />
  </svg>
  <svg
    v-else-if="name === 'collection'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
  </svg>
  <svg
    v-else-if="name === 'list'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 6h16M4 10h16M4 14h16M4 18h16"
    />
  </svg>
  <svg
    v-else-if="name === 'download_cloud'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
    />
  </svg>
  <svg
    v-else-if="name === 'clipboard_check'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    />
  </svg>
  <svg
    v-else-if="name === 'star'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
    />
  </svg>
  <svg
    v-else-if="name === 'star_solid'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
    />
  </svg>
  <svg
    v-else-if="name === 'filter_solid'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="name === 'plus'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
    />
  </svg>
  <svg
    v-else-if="name === 'close'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
  <svg v-else-if="name === 'calendar'" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M4.75 8.75C4.75 7.64543 5.64543 6.75 6.75 6.75H17.25C18.3546 6.75 19.25 7.64543 19.25 8.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V8.75Z"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M8 4.75V8.25"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M16 4.75V8.25"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M7.75 10.75H16.25"
    />
  </svg>

  <svg
    v-else-if="name === 'check'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 13l4 4L19 7"
    />
  </svg>
  <svg
    v-else-if="name === 'slash'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
  </svg>
  <svg
    v-else-if="name === 'refresh'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    />
  </svg>
  <svg
    v-else-if="name === 'pencil_edit'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
  </svg>
  <svg
    v-else-if="name === 'duplicate'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
  <svg
    v-else-if="name === 'trash_bin'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
  <svg
    v-else-if="name === 'bell'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
  <svg
    v-else-if="name === 'chat_alt'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
    />
  </svg>

  <svg v-else-if="name === 'message'" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M12 18.25C15.5 18.25 19.25 16.5 19.25 12C19.25 7.5 15.5 5.75 12 5.75C8.5 5.75 4.75 7.5 4.75 12C4.75 13.0298 4.94639 13.9156 5.29123 14.6693C5.50618 15.1392 5.62675 15.6573 5.53154 16.1651L5.26934 17.5635C5.13974 18.2547 5.74527 18.8603 6.43651 18.7307L9.64388 18.1293C9.896 18.082 10.1545 18.0861 10.4078 18.1263C10.935 18.2099 11.4704 18.25 12 18.25Z"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M9.5 12C9.5 12.2761 9.27614 12.5 9 12.5C8.72386 12.5 8.5 12.2761 8.5 12C8.5 11.7239 8.72386 11.5 9 11.5C9.27614 11.5 9.5 11.7239 9.5 12Z"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M15.5 12C15.5 12.2761 15.2761 12.5 15 12.5C14.7239 12.5 14.5 12.2761 14.5 12C14.5 11.7239 14.7239 11.5 15 11.5C15.2761 11.5 15.5 11.7239 15.5 12Z"
    />
  </svg>
  <svg
    v-else-if="name === 'rss'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'lock'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
    />
  </svg>
  <svg
    v-else-if="name === 'adjust_alt'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    />
  </svg>
  <svg
    v-else-if="name === 'users_group'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'code'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    />
  </svg>
  <svg
    v-else-if="name === 'upload'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
    />
  </svg>
  <svg
    v-else-if="name === 'support'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'hashtag'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
    />
  </svg>
  <svg
    v-else-if="name === 'folder'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
    />
  </svg>
  <svg
    v-else-if="name === 'chart'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
    />
  </svg>
  <svg
    v-else-if="name === 'questions'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
    />
  </svg>
  <svg
    v-else-if="name === 'notifications'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 611.999 611.999"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M570.107,500.254c-65.037-29.371-67.511-155.441-67.559-158.622v-84.578c0-81.402-49.742-151.399-120.427-181.203
          C381.969,34,347.883,0,306.001,0c-41.883,0-75.968,34.002-76.121,75.849c-70.682,29.804-120.425,99.801-120.425,181.203v84.578
          c-0.046,3.181-2.522,129.251-67.561,158.622c-7.409,3.347-11.481,11.412-9.768,19.36c1.711,7.949,8.74,13.626,16.871,13.626
          h164.88c3.38,18.594,12.172,35.892,25.619,49.903c17.86,18.608,41.479,28.856,66.502,28.856
          c25.025,0,48.644-10.248,66.502-28.856c13.449-14.012,22.241-31.311,25.619-49.903h164.88c8.131,0,15.159-5.676,16.872-13.626
          C581.586,511.664,577.516,503.6,570.107,500.254z M484.434,439.859c6.837,20.728,16.518,41.544,30.246,58.866H97.32
          c13.726-17.32,23.407-38.135,30.244-58.866H484.434z M306.001,34.515c18.945,0,34.963,12.73,39.975,30.082
          c-12.912-2.678-26.282-4.09-39.975-4.09s-27.063,1.411-39.975,4.09C271.039,47.246,287.057,34.515,306.001,34.515z
          M143.97,341.736v-84.685c0-89.343,72.686-162.029,162.031-162.029s162.031,72.686,162.031,162.029v84.826
          c0.023,2.596,0.427,29.879,7.303,63.465H136.663C143.543,371.724,143.949,344.393,143.97,341.736z M306.001,577.485
          c-26.341,0-49.33-18.992-56.709-44.246h113.416C355.329,558.493,332.344,577.485,306.001,577.485z"
    />
  </svg>
  <svg
    v-else-if="name === 'addTextSlider'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    stroke="currentColor"
  >
    <path d="M4 8H32" stroke-width="3" stroke-linecap="round" />
    <path d="M28 21H44" stroke-width="3" stroke-linecap="round" />
    <path d="M18 42L18 8" stroke-width="3" stroke-linecap="round" />
    <path d="M36 42L36 21" stroke-width="3" stroke-linecap="round" />
  </svg>
  <svg
    v-else-if="name === 'imgSlider'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 58 58"
    stroke="currentColor"
  >
    <path
      stroke-width="3"
      d="M57,6H1C0.448,6,0,6.447,0,7v44c0,0.553,0.448,1,1,1h56c0.552,0,1-0.447,1-1V7C58,6.447,57.552,6,57,6z M56,50H2V8h54V50z"
    />
    <path
      stroke-width="3"
      d="M16,28.138c3.071,0,5.569-2.498,5.569-5.568C21.569,19.498,19.071,17,16,17s-5.569,2.498-5.569,5.569
      C10.431,25.64,12.929,28.138,16,28.138z M16,19c1.968,0,3.569,1.602,3.569,3.569S17.968,26.138,16,26.138s-3.569-1.601-3.569-3.568
      S14.032,19,16,19z"
    />
    <path
      stroke-width="3"
      d="M7,46c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.391,0.391,1.023,0.391,1.414,0s0.391-1.023,0-1.414
      l-4.807-4.807l9.181-10.054l11.261,10.323c0.407,0.373,1.04,0.345,1.413-0.062c0.373-0.407,0.346-1.04-0.062-1.413l-12-11
      c-0.196-0.179-0.457-0.268-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325l-9.794,10.727l-4.743-4.743
      c-0.374-0.373-0.972-0.392-1.368-0.044L6.339,44.249c-0.415,0.365-0.455,0.997-0.09,1.412C6.447,45.886,6.723,46,7,46z"
    />
  </svg>
  <svg
    v-else-if="name === 'setting'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    stroke="currentColor"
  >
    <path
      stroke-width="3"
      d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"
    />
  </svg>

  <!-- Donovann -->
  <svg
    v-else-if="name === 'certificate'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1202 1024"
    stroke="currentColor"
  >
    <path d="M814.477972 815.866681a22.219348 22.219348 0 0 1-17.358866-7.637901l-35.759263-41.834866-53.118128 12.845561a21.872171 21.872171 0 0 1-17.358866-3.471773 22.219348 22.219348 0 0 1-9.02661-16.143745L676.995757 704.94353l-49.993533-21.004227a21.698582 21.698582 0 0 1-10.241731-31.593135l28.642128-46.868937-28.642128-46.695349a22.392937 22.392937 0 0 1-2.256652-17.358865 21.872171 21.872171 0 0 1 12.498383-13.539915L676.995757 506.18452l5.034071-54.854016a22.045759 22.045759 0 0 1 27.07983-19.615518l53.118129 13.01915L798.507816 402.89927a22.740114 22.740114 0 0 1 33.329022 0l34.717731 41.834866 53.465306-13.01915a22.219348 22.219348 0 0 1 17.358865 3.645362 21.872171 21.872171 0 0 1 9.02661 15.970156l4.166128 54.854016 50.687887 20.830638a21.872171 21.872171 0 0 1 12.498384 13.539915 21.177816 21.177816 0 0 1-2.256653 17.358866l-28.642128 46.695348 28.642128 46.868937a20.830639 20.830639 0 0 1 2.256653 17.358866 21.872171 21.872171 0 0 1-12.498384 13.539915l-50.687887 21.004227-4.166128 54.680427A21.872171 21.872171 0 0 1 920.019875 779.239475l-53.291718-12.845561-34.717731 41.834866a22.566525 22.566525 0 0 1-17.532454 7.637901z m-44.265107-95.820938a21.872171 21.872171 0 0 1 17.358865 7.637901l27.600597 32.461079 27.774184-32.461079a22.045759 22.045759 0 0 1 21.872171-7.117135l41.3141 10.068142 3.298185-42.52922a21.698582 21.698582 0 0 1 13.539915-18.400398l39.404625-16.490922-22.219348-36.280029a21.872171 21.872171 0 0 1 0-22.913703l22.219348-36.280029-39.404625-16.317333a22.219348 22.219348 0 0 1-13.539915-18.573986l-3.298185-42.529221-41.3141 10.068142a22.219348 22.219348 0 0 1-21.872171-7.117135L814.477972 451.330504l-27.600596 32.461079a21.872171 21.872171 0 0 1-21.698582 7.117135l-41.487689-10.068142-3.298184 42.529221a22.219348 22.219348 0 0 1-13.539916 18.573986l-39.404624 16.317333 22.219348 36.280029a21.004227 21.004227 0 0 1 0 22.913703l-22.219348 36.280029 39.404624 16.490922a21.698582 21.698582 0 0 1 13.539916 18.400398l3.298184 42.52922 41.487689-10.068142a24.823178 24.823178 0 0 1 5.034071-1.041532z" />
    <path d="M875.234001 768.476978v178.449138l-44.785873-47.042526a21.698582 21.698582 0 0 0-31.766724 0l-44.612284 47.042526V768.476978l-43.744341 10.41532v223.235011a21.872171 21.872171 0 0 0 13.713503 20.309872 22.392937 22.392937 0 0 0 23.955235-5.381248l66.484455-70.303405 66.658044 70.303405a21.698582 21.698582 0 0 0 15.796567 6.943546 21.351405 21.351405 0 0 0 8.158667-1.562298 21.698582 21.698582 0 0 0 13.887093-20.309872V778.892298z" />
    <path d="M999.002713 89.224569H203.445904a114.221335 114.221335 0 0 0-114.221335 114.221335v528.230279a114.221335 114.221335 0 0 0 114.221335 114.221336h506.878875v-43.744342h-506.878875a70.650583 70.650583 0 0 1-70.650582-70.476994V203.445904a70.650583 70.650583 0 0 1 70.650582-70.476994h795.556809a70.476994 70.476994 0 0 1 70.476994 70.476994v528.230279a70.476994 70.476994 0 0 1-70.476994 70.476994h-80.02437v43.744342h80.02437a114.394924 114.394924 0 0 0 114.221335-114.221336V203.445904a114.394924 114.394924 0 0 0-114.221335-114.221335z" />
    <path d="M1019.833352 0H182.441677A182.615266 182.615266 0 0 0 0 182.441677v570.238734a182.615266 182.615266 0 0 0 182.441677 182.441677h527.883102v-43.744342H182.441677a138.870924 138.870924 0 0 1-138.870924-138.870924V182.441677a138.870924 138.870924 0 0 1 138.870924-138.870924h837.391675a138.870924 138.870924 0 0 1 138.870924 138.870924v570.238734a138.870924 138.870924 0 0 1-138.870924 138.870924h-100.855009v43.744341h100.855009a182.788854 182.788854 0 0 0 182.615265-182.615265V182.441677A182.788854 182.788854 0 0 0 1019.833352 0z" />
    <path d="M862.56203 257.779154H339.886588a21.872171 21.872171 0 1 1 0-43.570753h522.675442a21.872171 21.872171 0 1 1 0 43.570753zM957.688613 368.00795H244.760004a22.045759 22.045759 0 1 1 0-43.91793h712.928609a22.045759 22.045759 0 1 1 0 43.91793zM601.137514 478.063157H244.760004a22.045759 22.045759 0 1 1 0-43.917929h356.37751a22.045759 22.045759 0 0 1 0 43.917929zM458.794817 619.537912H244.760004a22.045759 22.045759 0 1 1 0-43.91793h214.034813a22.045759 22.045759 0 1 1 0 43.91793zM458.794817 729.072353H244.760004a21.872171 21.872171 0 1 1 0-43.744341h214.034813a21.872171 21.872171 0 1 1 0 43.744341z" />
  </svg>

  <svg
    v-else-if="name === 'credential'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1024 1024"
    stroke="currentColor"
  >
    <path d="M950.8864 146.3296c21.2992 0 38.8096 6.8608 52.5312 20.5824C1017.1392 180.5312 1024 198.0416 1024 219.4432l0 585.1136c0 21.4016-6.8608 38.8096-20.5824 52.5312C989.696 870.8096 972.1856 877.6704 950.8864 877.6704L73.1136 877.6704c-21.2992 0-38.8096-6.8608-52.5312-20.5824C6.8608 843.4688 0 825.9584 0 804.5568L0 219.4432c0-21.2992 6.8608-38.912 20.5824-52.5312 13.7216-13.7216 31.232-20.5824 52.5312-20.5824l365.6704 0 0-128C438.8864 6.144 444.928 0 457.1136 0l109.6704 0c12.1856 0 18.3296 6.144 18.3296 18.3296l0 128L950.8864 146.3296zM987.4432 219.4432c0-24.3712-12.1856-36.5568-36.5568-36.5568L585.1136 182.8864l0 54.8864c0 12.288-6.144 18.3296-18.3296 18.3296L457.1136 256.1024c-12.1856 0-18.3296-6.0416-18.3296-18.3296L438.784 182.8864 73.1136 182.8864c-24.3712 0-36.5568 12.288-36.5568 36.5568l0 585.1136c0 24.3712 12.1856 36.5568 36.5568 36.5568l877.6704 0c24.3712 0 36.5568-12.1856 36.5568-36.5568L987.3408 219.4432zM438.8864 676.5568c0-35.0208-12.5952-65.1264-37.6832-90.3168S345.9072 548.5568 310.8864 548.5568 245.76 561.152 220.5696 586.24 182.8864 641.536 182.8864 676.5568c0 12.288-6.144 18.3296-18.3296 18.3296S146.3296 688.8448 146.3296 676.5568c0-45.6704 15.9744-84.5824 48.0256-116.5312C226.304 527.9744 265.1136 512 310.8864 512c45.6704 0 84.5824 15.9744 116.5312 48.0256 31.9488 31.9488 48.0256 70.8608 48.0256 116.5312 0 12.288-6.144 18.3296-18.3296 18.3296S438.8864 688.8448 438.8864 676.5568zM374.8864 484.5568C356.5568 502.8864 335.2576 512 310.8864 512S265.1136 502.8864 246.8864 484.5568 219.4432 444.928 219.4432 420.5568c0-24.3712 9.1136-45.6704 27.4432-64s39.6288-27.4432 64-27.4432 45.6704 9.1136 64 27.4432S402.3296 396.288 402.3296 420.5568C402.3296 444.928 393.1136 466.3296 374.8864 484.5568zM349.696 381.7472C339.0464 371.0976 326.144 365.6704 310.8864 365.6704c-15.2576 0-28.16 5.4272-38.8096 15.9744C261.3248 392.3968 256 405.4016 256 420.5568c0 15.2576 5.3248 28.2624 15.9744 38.8096C282.624 470.1184 295.6288 475.4432 310.8864 475.4432c15.2576 0 28.16-5.3248 38.8096-15.9744 10.6496-10.6496 15.9744-23.6544 15.9744-38.8096C365.6704 405.4016 360.3456 392.3968 349.696 381.7472zM475.4432 219.4432l73.1136 0L548.5568 36.5568 475.4432 36.5568 475.4432 219.4432zM859.4432 365.6704l-256 0c-12.1856 0-18.3296-6.0416-18.3296-18.3296 0-12.1856 6.144-18.3296 18.3296-18.3296l256 0c12.1856 0 18.3296 6.144 18.3296 18.3296C877.6704 359.6288 871.6288 365.6704 859.4432 365.6704zM859.4432 475.4432l-256 0c-12.1856 0-18.3296-6.0416-18.3296-18.3296 0-12.1856 6.144-18.3296 18.3296-18.3296l256 0c12.1856 0 18.3296 6.144 18.3296 18.3296C877.6704 469.4016 871.6288 475.4432 859.4432 475.4432zM859.4432 585.1136l-256 0c-12.1856 0-18.3296-6.0416-18.3296-18.3296 0-12.1856 6.144-18.3296 18.3296-18.3296l256 0c12.1856 0 18.3296 6.144 18.3296 18.3296C877.6704 579.072 871.6288 585.1136 859.4432 585.1136zM859.4432 694.8864l-256 0c-12.1856 0-18.3296-6.0416-18.3296-18.3296 0-12.1856 6.144-18.3296 18.3296-18.3296l256 0c12.1856 0 18.3296 6.144 18.3296 18.3296C877.6704 688.8448 871.6288 694.8864 859.4432 694.8864z" />
  </svg>

  <svg
    v-else-if="name === 'hybrid'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 50 50"
    stroke="currentColor"
  >
    <g>
      <path 
      d="M25,11.56L25,11.56c1.53,0,3-0.61,4.08-1.69c1.08-1.08,1.69-2.55,1.69-4.08s-0.61-3-1.69-4.08C28,0.61,26.53,0.01,25,0.01
      s-3,0.61-4.08,1.69c-1.08,1.08-1.69,2.55-1.69,4.08c0,1.53,0.61,3,1.69,4.08C22,10.95,23.46,11.55,25,11.56z M22.71,3.49
      c0.61-0.61,1.43-0.95,2.29-0.95c0.86,0,1.68,0.34,2.29,0.95c0.61,0.61,0.95,1.43,0.95,2.29c0,0.86-0.34,1.68-0.95,2.29
      C26.68,8.68,25.85,9.02,25,9.02s-1.68-0.34-2.29-0.95c-0.61-0.61-0.95-1.43-0.95-2.29C21.76,4.92,22.1,4.1,22.71,3.49z"/>
      <path 
      d="M15.21,18.49L15.21,18.49l0,0.05l1.17,7.65h0c0.17,1.48,1.04,2.78,2.33,3.52l1.87,12.76c0.08,0.69,0.42,1.32,0.93,1.78
        c0.52,0.46,1.19,0.71,1.88,0.71h3.2c0.69,0,1.36-0.25,1.88-0.71c0.52-0.46,0.85-1.09,0.93-1.78l1.87-12.76h0
        c1.29-0.73,2.16-2.04,2.33-3.52l1.17-7.65v-0.05c0.17-1.5-0.31-3-1.31-4.12c-1-1.12-2.44-1.77-3.94-1.77h-1.46
        c-0.45,0-0.87,0.2-1.14,0.55l-1.92,2.37l-1.89-2.36c-0.28-0.36-0.71-0.56-1.17-0.56h-1.48c-1.51,0.01-2.94,0.65-3.94,1.78
        C15.52,15.49,15.04,16.99,15.21,18.49z M18.41,16.05L18.41,16.05L18.41,16.05c0.52-0.59,1.26-0.92,2.04-0.92h0.97l2.14,2.68
        c0.33,0.42,0.84,0.67,1.38,0.66h0.07c0.53,0,1.04-0.24,1.37-0.66l2.18-2.68h0.96c0.78,0,1.53,0.33,2.06,0.92
        c0.52,0.58,0.77,1.36,0.69,2.14l-1.16,7.65v0.05c-0.04,0.4-0.2,0.78-0.45,1.09c-0.25,0.31-0.58,0.55-0.96,0.69
        c-0.44,0.16-0.75,0.56-0.82,1.02l-2.01,13.4v0.04c-0.02,0.15-0.14,0.27-0.3,0.27h-3.2c-0.15,0-0.28-0.11-0.3-0.27V42.1l-1.97-13.43
        c-0.06-0.46-0.38-0.86-0.82-1.02c-0.38-0.14-0.71-0.37-0.96-0.69c-0.25-0.31-0.4-0.69-0.45-1.09v-0.05l-1.17-7.65v0
        C17.65,17.4,17.9,16.63,18.41,16.05z"/>
      <path 
      d="M33.49,38.31L33.49,38.31c-0.69-0.14-1.36,0.3-1.5,0.99c-0.14,0.69,0.3,1.36,0.99,1.5c4.72,0.95,6.25,2.4,6.25,2.95
        c0,0.45-0.97,1.44-3.66,2.3c-3.43,0.98-7,1.45-10.57,1.39c-3.58,0.06-7.14-0.41-10.58-1.39c-2.68-0.86-3.66-1.84-3.66-2.3
        c0-0.56,1.53-2.01,6.25-2.95h0c0.69-0.14,1.13-0.81,0.99-1.5c-0.14-0.69-0.81-1.13-1.5-0.99c-5.33,1.08-8.28,3.01-8.28,5.44
        c0,1.36,0.94,3.28,5.42,4.71v0c3.69,1.07,7.51,1.58,11.35,1.53c3.84,0.05,7.67-0.46,11.35-1.53c4.46-1.43,5.42-3.35,5.42-4.71l0,0
        C41.77,41.32,38.83,39.39,33.49,38.31z"/>
      <path 
      d="M39.2,10.3L39.2,10.3c1.37,0,2.68-0.54,3.64-1.5c0.97-0.96,1.51-2.27,1.51-3.64c0-1.37-0.54-2.68-1.51-3.64
        C41.88,0.54,40.57,0,39.21,0c-1.37,0-2.68,0.54-3.64,1.51c-0.97,0.97-1.51,2.28-1.51,3.64c0,1.36,0.54,2.67,1.51,3.64
        C36.53,9.75,37.84,10.29,39.2,10.3z M37.36,3.31c0.49-0.49,1.15-0.76,1.84-0.76v0c0.69,0,1.36,0.27,1.84,0.76
        c0.49,0.49,0.76,1.15,0.76,1.84s-0.27,1.36-0.76,1.84c-0.49,0.49-1.15,0.76-1.84,0.76c-0.69,0-1.35-0.27-1.84-0.76
        c-0.49-0.49-0.76-1.15-0.76-1.84C36.59,4.46,36.87,3.8,37.36,3.31z"/>
      <path 
      d="M46.63,13.15c-0.9-1-2.19-1.58-3.53-1.57l-1.26,0c-0.44,0-0.85,0.2-1.12,0.54l-1.49,1.87l-1.49-1.87h0
        c-0.44-0.56-1.24-0.65-1.8-0.21c-0.56,0.44-0.65,1.24-0.21,1.8l2.12,2.65l0,0c0.33,0.4,0.83,0.64,1.35,0.64
        c0.52,0,1.02-0.23,1.35-0.64l1.81-2.23h0.74c0.62,0,1.22,0.26,1.63,0.73c0.42,0.46,0.62,1.08,0.56,1.7l-1.02,6.58v0.05l0,0
        c-0.03,0.31-0.16,0.6-0.35,0.85c-0.19,0.24-0.45,0.43-0.74,0.54c-0.44,0.16-0.76,0.55-0.82,1.02l-1.68,12.04
        c-0.1,0.69,0.39,1.34,1.08,1.43h0.18c0.63,0,1.17-0.47,1.25-1.09l1.6-11.37c1.12-0.67,1.86-1.82,2.01-3.12l1.02-6.59v-0.05
        C47.96,15.49,47.53,14.15,46.63,13.15z"/>
      <path 
      d="M10.79,10.3L10.79,10.3c1.37,0,2.67-0.54,3.64-1.51c0.97-0.97,1.51-2.28,1.51-3.64c0-1.37-0.54-2.67-1.51-3.64
        C13.46,0.54,12.15,0,10.79,0C9.42,0,8.11,0.54,7.15,1.51C6.18,2.47,5.64,3.78,5.64,5.15c0,1.36,0.54,2.67,1.51,3.64
        C8.12,9.75,9.42,10.3,10.79,10.3z M8.93,3.3c0.49-0.49,1.16-0.76,1.86-0.76l0,0v0c0.69,0.01,1.35,0.29,1.83,0.78
        c0.48,0.49,0.75,1.16,0.75,1.85c0,0.69-0.28,1.35-0.77,1.84c-0.49,0.49-1.15,0.76-1.84,0.75c-0.69,0-1.35-0.28-1.84-0.77
        C8.43,6.5,8.16,5.84,8.16,5.15C8.16,4.45,8.44,3.79,8.93,3.3z"/>
      <path 
      d="M9.33,37.6L7.65,25.57c-0.06-0.47-0.38-0.86-0.82-1.02c-0.29-0.11-0.55-0.29-0.74-0.54c-0.19-0.24-0.31-0.54-0.35-0.85
        v-0.05l-1.02-6.58l0,0c-0.06-0.62,0.14-1.24,0.56-1.7c0.42-0.46,1.01-0.73,1.63-0.73h0.74l1.79,2.23c0.32,0.4,0.81,0.64,1.32,0.64
        h0.03c0.52,0.01,1.03-0.22,1.35-0.63l2.14-2.65c0.39-0.55,0.29-1.31-0.24-1.73c-0.53-0.42-1.29-0.36-1.74,0.14l-1.49,1.87
        l-1.49-1.86h0c-0.28-0.36-0.71-0.56-1.16-0.55H6.88c-1.34,0-2.62,0.58-3.52,1.58c-0.89,1-1.32,2.34-1.17,3.67L2.2,16.9l1.01,6.57
        c0.15,1.29,0.89,2.44,2.01,3.11l1.6,11.37c0.09,0.63,0.62,1.09,1.25,1.09h0.18C8.94,38.94,9.43,38.3,9.33,37.6z"/>
    </g>
  </svg>
  <svg 
    v-else-if="name === 'matchmaking'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960" 
    stroke="currentColor"
  >
      <path
          d="M480.356-880q41.644 0 77.144 7 35.5 7 85.5 26l-82 36q-19-5-36-7t-45-2q-20 0-45.5 3T388-807q75 85 153.5 137T761-630l23 57q-133 17-231.5-25T383-722q-34 81-97.5 141.5T140-487q0 145 99 246t241 101q143 0 241.5-99.5T820-480q0-22-2.5-39.5L813-551l36-85q16 43 23.5 77t7.5 79q0 83-31 156t-85 127q-54 54-127 85.5T480-80q-84 0-157-31t-127-85q-54-54-85-127T80-480q0-84 31-157t85-127q54-54 127-85t157.356-31ZM354.225-491Q377-491 392.5-475.275q15.5 15.726 15.5 38.5Q408-414 392.275-398.5q-15.726 15.5-38.5 15.5Q331-383 315.5-398.725q-15.5-15.726-15.5-38.5Q300-460 315.725-475.5q15.726-15.5 38.5-15.5ZM575-717Zm32.225 226Q630-491 645.5-475.275q15.5 15.726 15.5 38.5Q661-414 645.275-398.5q-15.726 15.5-38.5 15.5Q584-383 568.5-398.725q-15.5-15.726-15.5-38.5Q553-460 568.725-475.5q15.726-15.5 38.5-15.5ZM804-943l44 102 99 41-99 42-44 102-45-102-99-42 99-41 45-102ZM150-560q48-18 109.5-81T347-794q-87 39-131.5 99T150-560Zm197-234Z" />
  </svg>

  <svg 
    v-else-if="name === 'gateway'"
    xmlns="http://www.w3.org/2000/svg" 
    fill="none"
    viewBox="0 0 64 64" 
    stroke="currentColor" 
    stroke-width="3" 
  >
    <path d="M50.93,34.13v7.93a2.75,2.75,0,0,1-2.75,2.76H12.09A2.85,2.85,0,0,1,9.24,42V18a1.8,1.8,0,0,1,1.81-1.8H29.1"/>
    <path d="M51.39,50.87H9.48a4.11,4.11,0,0,1-4.12-4.12V44.82H55v2.4A3.65,3.65,0,0,1,51.39,50.87Z"/>
    <path d="M31.64,13.13H56.5a2.14,2.14,0,0,1,2.14,2.14V31.66A2.14,2.14,0,0,1,56.5,33.8H30.77a2.14,2.14,0,0,1-2.14-2.14V16.13A3,3,0,0,1,31.64,13.13Z"/>
    <line x1="28.63" y1="17.53" x2="58.64" y2="17.53"/>
    <line x1="28.63" y1="21.36" x2="58.64" y2="21.36"/>
    <path d="M52.9,25.77a2.35,2.35,0,0,0-1.42.49,2.37,2.37,0,0,0-1.43-.49,2.33,2.33,0,1,0,0,4.66,2.37,2.37,0,0,0,1.43-.49,2.33,2.33,0,1,0,1.42-4.17Z"/>
  </svg>
  <svg
    v-else-if="name === 'key'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="3"
  >
    <path d="M17.2606 11.4402C19.8781 11.4402 22 9.3269 22 6.72008C22 4.11325 19.8781 2 17.2606 2C14.643 2 12.5211 4.11325 12.5211 6.72008C12.5211 7.92754 13.0722 8.80569 13.0722 8.80569L7.3408 14.5137C7.08363 14.7698 6.72357 15.4358 7.3408 16.0505L8.00212 16.7091C8.25929 16.9286 8.90589 17.236 9.43495 16.7091L10.2065 15.9407C10.978 16.7091 11.8598 16.27 12.1904 15.8309C12.7415 15.0625 12.0802 14.2942 12.0802 14.2942L12.3007 14.0746C13.3588 15.1284 14.2846 14.5137 14.6153 14.0746C15.1664 13.3062 14.6153 12.5378 14.6153 12.5378C14.3948 12.0988 13.954 12.0988 14.505 11.5499L15.1664 10.8913C15.6954 11.3304 16.7829 11.4402 17.2606 11.4402Z" stroke="#1C274C" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M2 11.9899C2 16.7087 2 19.0681 3.46594 20.5341C4.93188 22 7.29127 22 12.0101 22C16.7288 22 19.0882 22 20.5542 20.5341C21.6692 19.419 21.9361 17.787 22 14.993M9.00704 2C6.21298 2.06388 4.58099 2.33078 3.46594 3.44584C2.48914 4.42263 2.16321 5.79612 2.05446 8" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
  <svg
    v-else-if="name === 'videocall'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
  >
    <path d="M5 18H15C16.1046 18 17 17.1046 17 16V8.57143V8C17 6.89543 16.1046 6 15 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="6.5" cy="9.5" r="0.5" stroke-linejoin="round"/>
    <path d="M17 10L21 7V17L17 14" stroke-linejoin="round"/>
  </svg>
  <svg
    v-else-if="name === 'card_view'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
  >
    <circle cx="9" cy="9" r="2" stroke-width="1.5" />
    <path d="M13 15C13 16.1046 13 17 9 17C5 17 5 16.1046 5 15C5 13.8954 6.79086 13 9 13C11.2091 13 13 13.8954 13 15Z" stroke-width="1.5" />
    <path d="M22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C21.298 5.64118 21.5794 6.2255 21.748 7" stroke-width="1.5" stroke-linecap="round" />
    <path d="M19 12H15" stroke-width="1.5" stroke-linecap="round" />
    <path d="M19 9H14" stroke-width="1.5" stroke-linecap="round" />
    <path d="M19 15H16" stroke-width="1.5" stroke-linecap="round" />
  </svg>
  <v-icon v-else-if="name === 'mdIcon'">
    {{ mdIcon }}
  </v-icon>
  <GDynamicIcon v-else-if="name === 'g-next'" :component-name="gNext">
    {{ gNext }}
  </GDynamicIcon>
</template>

<script>
import { formatterArray } from '@/utils/formatterArray'
import GDynamicIcon from './GDynamicIcon.vue'
const values = [
  'notifications',
  'mdIcon',
  'g-next',
  'hashtag',
  'users',
  'v-rooms',
  'cog',
  'award',
  'trash_bin',
  'duplicate',
  'plus',
  'filter_solid',
  'support',
  'star_solid',
  'star',
  'clipboard_check',
  'questions',
  'chart',
  'folder',
  'upload',
  'download_cloud',
  'rss',
  'code',
  'adjust_alt',
  'users_group',
  'lock',
  'list',
  'chat_alt',
  'collection',
  'email',
  'phone',
  'search',
  'add_user',
  'pencil_edit',
  'message',
  'close',
  'bell',
  'calendar',
  'slash',
  'check',
  'refresh',
  'addTextSlider',
  'imgSlider',
  'setting',
  'certificate',
  'credential',
  'hybrid',
  'matchmaking',
  'gateway',
  'key',
  'videocall',
  'card_view',
]
export default {
  components: {
    GDynamicIcon,
  },
  props: {
    mdIcon: {
      type: String,
      default: '',
    },
    gNext: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
      validator(v) {
        const isValid = values.includes(v)
        if (!isValid) {
          console.error(
            'Wrong value for the `componentName` prop. ' +
              `Given: "${v}", expected one of: "${formatterArray().format(
                values,
              )}".`,
          )
        }
        return isValid
      },
    },
  },
}
</script>
